import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-uploadsidebar',
    templateUrl: './uploadsidebar.component.html',
    styleUrls: ['./uploadsidebar.component.scss'],
    standalone: false
})
export class UploadsidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
